/*
 * @Author: edvardchen
 * @Date: 2017-11-08 17:35:16
 * @Last Modified by: tofuxbchen
 * @Last Modified time: 2020-09-01 20:20:59
 */

// @flow
import _ from 'lodash';
import { ActionTypes } from 'redux/lib/createStore';
import { type Reducer, initialState } from '../types';
import pipe from '../pipe';

import {
  RESET_ALLCOMMENTS,
  PRAISE_POST,
  RESET_POST,
  UPDATE_POST,
  HIDE_OPTIONS,
  SHOW_OPTIONS,
  PRAISE_COMMENT,
  ADD_HOT,
  RESET_COMMENT,
  ENABLE_NESTED_COMMENTS,
  SHOW_ACCUSE_MODAL,
  CLOSE_ACCUSE_MODAL,
  RESTOTHERFTSTATE,
  RESET_HOTCOMMENTS,
  RESET_USER_HONORS,
  SHOW_CONFIRM_MODAL,
  CLOSE_CONFIRM_MODAL,
  SHOW_COMMENT_SHARE_MODAL,
  CLOSE_COMMENT_SHARE_MODAL,
  RESET_OPERATE_BAR,
  CANCEL_PRAISE_POST,
} from './actions';

import fetchReducer from './moreFetchReducer';
import tweetReducer from './tweetReducer';
import itemReducer from './itemReducer';
import { supportNestedComments } from '../../utility/index';
import { DISABLE_NESTED_COMMENTS } from './index';

const combined = pipe(fetchReducer, tweetReducer);

const reducer: Reducer = (state, action) => {
  const { type, payload } = action;
  const { hotComments, allComments } = state;
  switch (type) {
    case '@@INIT': // redux-tools下redux初始化的action会被错误的设计成@@INIT
    case ActionTypes.INIT: {
      // 如果没有显式设置是否开启楼中楼，用终端版本判断
      if (__CLIENT__ && state.showNestedComments === undefined) {
        return {
          ...state,
          showNestedComments: supportNestedComments(_.get(global, 'browser.env.version')),
        };
      }
      return state;
    }
    case ENABLE_NESTED_COMMENTS:
      return {
        ...state,
        showNestedComments: true,
      };
    case DISABLE_NESTED_COMMENTS:
      return {
        ...state,
        showNestedComments: false,
      };
    case RESET_ALLCOMMENTS:
      return {
        ...state,
        allComments: payload,
      };
    case RESET_HOTCOMMENTS:
      return {
        ...state,
        hotComments: payload,
      };
    case RESET_POST:
      return {
        ...state,
        postInfo: {
          ...initialState.postInfo,
          ...payload,
        },
      };
    case UPDATE_POST:
      return {
        ...state,
        postInfo: {
          ...state.postInfo,
          ...payload,
        },
      };
    case RESET_COMMENT:
      return {
        ...state,
        comment: payload,
      };
    case RESTOTHERFTSTATE:
      return {
        ...state,
        apps: {
          isOtherFt: payload || false,
        },
      };
    case ADD_HOT: {
      if (!payload) {
        return state;
      }
      return {
        ...state,
        hotComments: hotComments.concat(payload).map((item) => ({ ...item, __listId: `hot_$${item.id}` })), // 区分全部评论和热门评论
      };
    }
    case PRAISE_POST: {
      const { postInfo } = state;
      const { praised, praiseNum, ...rest } = postInfo;
      if (praised) {
        return state;
      }
      return {
        ...state,
        postInfo: {
          ...rest,
          praiseNum: (praiseNum || 0) + 1,
          praised: true,
        },
      };
    }
    case CANCEL_PRAISE_POST: {
      const { postInfo } = state;
      const { praised, praiseNum, ...rest } = postInfo;
      if (!praised) {
        return state;
      }
      return {
        ...state,
        postInfo: {
          ...rest,
          praiseNum: (praiseNum || 1) - 1,
          praised: false,
        },
      };
    }
    case PRAISE_COMMENT:
    case HIDE_OPTIONS:
      return {
        ...state,
        hotComments: hotComments.map((item) => itemReducer(item, action)),
        allComments: {
          ...allComments,
          items: allComments.items.map((item) => itemReducer(item, action)),
        },
      };
    case SHOW_OPTIONS: {
      if (!payload) {
        return state;
      }
      // 两个评论列表可能会有相同的评论
      if (payload.__listId) {
        return {
          ...state,
          hotComments: hotComments.map((item) => itemReducer(item, action)),
        };
      }
      return {
        ...state,
        allComments: {
          ...allComments,
          items: allComments.items.map((item) => itemReducer(item, action)),
        },
      };
    }
    case SHOW_ACCUSE_MODAL:
      return {
        ...state,
        accuseModal: {
          ...payload,
          show: true,
        },
      };
    case CLOSE_ACCUSE_MODAL:
      return {
        ...state,
        accuseModal: {
          show: false,
        },
      };
    case SHOW_COMMENT_SHARE_MODAL:
      return {
        ...state,
        commentShareModal: {
          ...payload,
          show: true,
        },
      };
    case CLOSE_COMMENT_SHARE_MODAL:
      return {
        ...state,
        commentShareModal: {
          show: false,
        },
      };
    case RESET_USER_HONORS:
      return {
        ...state,
        honorInfoEx: payload,
      };
    case SHOW_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          ...payload,
          show: true,
        },
      };
    case CLOSE_CONFIRM_MODAL:
      return {
        ...state,
        confirmModal: {
          show: false,
        },
      };
    case RESET_OPERATE_BAR:
      return {
        ...state,
        operateMsgs: payload,
      };
    default:
      return combined(state, { type, payload });
  }
};

export default reducer;
